<div class="card" style="margin-top: 20px;">
    <div class="card-header">An Error Has Occurred</div>
    <div class="card-body">
        <p>An application error has occurred. This has been logged and reported to our technology team.</p>
        <p>We recommend that you use <a href="https://www.google.com/chrome/browser/" target="_blank">Google
                Chrome</a> to access our website.</p>
        <p>If the problem persists, please contact our customer support.</p>
    </div>
</div>